import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const rootEl = document.getElementById("root")!;
rootEl.style.minHeight = "100vh";
rootEl.style.backgroundColor = "hsl(var(--innflow-background, 0 0% 0%))";

try {
  createRoot(rootEl).render(<App />);
} catch (err) {
  const message = err instanceof Error ? err.message : String(err);
  rootEl.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;font-family:system-ui,sans-serif;background:#000000;color:#fff;">
      <div style="max-width:480px;text-align:center;">
        <h1 style="color:#19F58C;margin-bottom:16px;">Erro ao carregar o INNFLOW</h1>
        <p style="color:#94a3b8;margin-bottom:24px;">${message.replace(/</g, "&lt;")}</p>
        <button onclick="window.location.reload()" style="padding:12px 24px;background:#19F58C;color:#000;border:none;border-radius:8px;cursor:pointer;font-weight:600;">Recarregar</button>
      </div>
    </div>
  `;
  console.error("INNFLOW mount error:", err);
}
